/* eslint-disable no-nested-ternary */
/** Шум Voximplant Kit (reconnect / View Transition), не наш код. */
export const isVoximplantNoiseError = (reason: unknown): boolean => {
  if (reason == null) return false

  const message =
    typeof reason === "string"
      ? reason
      : reason instanceof Error
      ? reason.message
      : typeof reason === "object" && "message" in reason
      ? String((reason as { message: unknown }).message)
      : String(reason)

  const stack =
    reason instanceof Error
      ? reason.stack ?? ""
      : typeof reason === "object" && reason !== null && "stack" in reason
      ? String((reason as { stack: unknown }).stack ?? "")
      : ""

  const name =
    reason instanceof Error
      ? reason.name
      : typeof reason === "object" && reason !== null && "name" in reason
      ? String((reason as { name: unknown }).name ?? "")
      : ""

  if (message.includes("Transition was aborted because of invalid state")) {
    return true
  }

  return name === "InvalidStateError" && stack.includes("kit.voximplant.com")
}
